// src/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import PageLoading from './components/PageLoading';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <PageLoading label="Checking account access" />;
  if (user) return children;
  const redirectPath = `${location.pathname}${location.search}${location.hash}`;
  return (
    <Navigate
      to="/"
      replace
      state={{ auth: 'signin', redirect: redirectPath }}
    />
  );
}
